import React from 'react';
import SubPageHeader from '../SubPageHeader';
import { Container, Content } from './styles';

const SubPage: React.FC = ({children}) => {
  return <Container>
      <SubPageHeader></SubPageHeader>
      <Content>
        {children}
      </Content>
  </Container>;
}

export default SubPage;